import classNames from 'classnames';
import {
	Button, DataDownload, Dialog, SuccessIcon,
} from '@aleph/shared-components';
import { TwoFactorStepProps } from 'wb-reddit/app/common/components/twoFactor/twoFactorAuthCodeStep';
import TwoFactorHeader from 'wb-reddit/app/common/components/twoFactor/twoFactorModalHeader';
import { usePDF } from '@react-pdf/renderer';
import { MyDocument } from 'wb-reddit/app/common/components/twoFactor/pdf';
import { useTranslation } from 'react-i18next';

export default function TwoFactorSuccessStep({
	recoveryCodes, type, email, onClose,
}: TwoFactorStepProps) {
	const { t } = useTranslation();

	const [{ loading, error, url }] = usePDF({
		document: <MyDocument email={email}
			recoveryCodes={recoveryCodes}
		/>,
	});

	return (
		<>
			<TwoFactorHeader
				type={type}
				onClose={onClose}
			/>
			<Dialog.Content>
				<div className={classNames('flex flex-col gap-4 max-w-[584px]', { 'items-center': type === 'disable' })}>
					<SuccessIcon
						width={96}
						height={96}
						className='self-center'
					/>
					<p className='text-base font-semibold !m-0'>
						{type === 'enable' ? t('sc: auth.tfa.recovery_codes', 'Recovery codes') : t('sc: auth.tfa.auth_disabled', 'Authentication disabled')}
					</p>
					<p className={classNames('!m-0', {
						'text-center': type === 'disable',
					})}
					>
						{
							type === 'enable'
								? t('sc: auth.tfa.recovery_codes_instruction', 'If you ever lose access to your Google Authenticator, you can use the following recovery codes to log-in. Please save them in a secure location.')
								: t('sc: auth.tfa.less_secure', 'Please note this makes your account less secure and prone to abuse by actors obtaining unauthorized access. Consider re-enabling it.')
						}
					</p>
					{
						type === 'enable'
							? <div className='grid grid-cols-3 gap-4'>
								{
									recoveryCodes.map((item) => (<div className='bg-gray-100 px-4 py-[13px] rounded-xl'>
										<p className='text-lg font-medium text-gray-950'>{item}</p>
									</div>))
								}
							</div> : null
					}
				</div>
			</Dialog.Content>
			{
				type === 'enable'
					? <Dialog.Footer>
						<a
							href={url ?? '#'}
							download="Wise.Blue Next Recovery Codes.pdf"
						>
							<Button
								title={t('sc: auth.tfa.download_pdf', 'Download PDF')}
								leftNode={<DataDownload />}
								loading={loading}
								disabled={loading || !!error}
							/>
						</a>
					</Dialog.Footer> : null
			}
		</>
	);
}
